import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { LocationFormComponent as EpLocationFormComponent } from '@ep/shared';
import { LocationFormService } from '@app/areas/merchants/services/location-form.service';

@Component({
  selector: 'app-location-form',
  templateUrl: './location-form.component.html',
  standalone: true,
  imports: [EpLocationFormComponent, AsyncPipe],
})
export class LocationFormComponent {
  private readonly locationFormService = inject(LocationFormService);

  protected locationForm = this.locationFormService.getForm();
  protected mode$ = this.locationFormService.mode$;
}
